module.exports = __webpack_public_path__ + "img/ico-pfwjt.276fc2ac.png";